import React from 'react';

import { Box, Typography } from '@mui/material';

interface SelectedProviderProps {
  selectedProvider: { providerName: string; vendorName: string } | null;
}

const SelectedProvider = ({ selectedProvider }: SelectedProviderProps) => {
  if (!selectedProvider) {
    return null;
  }

  return (
    <Box textAlign="left" display="flex" flexDirection="column">
      <Typography variant="title" noWrap>
        {selectedProvider.providerName}
      </Typography>
      <Typography variant="bodyS">{selectedProvider.vendorName}</Typography>
    </Box>
  );
};

export default SelectedProvider;
